<template>
  <div class="builder">
    <transition name="fade">
      <div
        v-if="submission_uuid && isFinal && showSubmit"
        class="messages__wrapper layout-container"
      >
        <div class="messages messages--status">
          This form was previously submitted. You may make edits and resubmit
          the form at any time.
          <div class="messages--link" v-html="getSubmissionLink(submission_id)"></div>
        </div>
      </div>
    </transition>
    <div v-if="is_closed">
      <div class="messages messages--warning" v-html="closed_message"></div>
    </div>
    <div>
      <component
        v-for="(element, index) in jsonView"
        :nid="nid"
        :sid="draft_submission_uuid"
        :main_sid="submission_uuid"
        :uuid="element.uuid"
        :key="element.uuid"
        :is="element.type"
        :index="index"
        :element="element"
        :mode="true"
        :validate="validate"
        :validate-last-step="validate"
        :is-draft="isDraft"
        :countFormCards="countFormCards"
        :status="status"
        :showSubmit="showSubmit"
        :go-view-mode="goViewMode"
        :set-view-mode="setViewMode"
        @submit="submit"
        @validate-form="validateForm"
        @disable-form-validation="disableFormValidation"
        @submit-draft="submitDraft"
        @autosave-start="startAutosave"
        @autosave-stop="stopAutosave"
        @set-value="setValue"
        @validation="updateValidation(index, $event)"
      />
      <div class="rubrics">
        <coach-rubrics
          ref="coachRubrics"
          feedbackUuid
          feedback
          :element_uuid="sid"
          :form="field"
          :is_final="isFinal"
          mode="learner"
        />
      </div>
    </div>
    <md-dialog-alert
      :md-active.sync="show_submitted"
      md-title="Activity"
      md-content="Your submission has been saved."
    />
    <md-button
      v-if="showSubmit && countFormCards > 1"
      class="md-raised md-accent icon-right fb-submit-btn right"
      @click="submit"
    >
      Submit
      <md-icon>send</md-icon>
    </md-button>
    <spinner v-if="showLoader"></spinner>
  </div>
</template>

<script>
import Spinner from "../components/Spinner.vue";
import Feedback from "../components/Feedback.vue";
import CoachRubrics from "../components/CoachRubrics";
import RestHelpers from "../services/RestHelpers";

export default {
  name: "FormViewer",
  props: [
    "nid",
    "sid",
    "draft_sid",
    "content",
    "embed",
    "field",
    "elements",
    "go-view-mode",
    "set-view-mode",
  ],
  components: {
    Spinner,
    Feedback,
    CoachRubrics,
  },
  created() {
    this.list.forEach((element) => {
      this.set_uuid(element);
    });
  },
  mounted() {
    let textarea;
    if (this.elements) {
      return;
    } else if (this.embed === true) {
      textarea = {
        value: JSON.stringify(
          window.drupalSettings.form_builder[this.nid].tabs[this.field].data
        ),
      };
    } else {
      textarea =
        this.$el.parentElement.parentElement.previousElementSibling.querySelector(
          "textarea"
        ) || document.querySelector("#form_builder_test_json");
    }
    if (textarea) {
      let json = textarea.value;
      if (json == "") {
        json = "[]";
      }

      let p_json = typeof json == "string" ? JSON.parse(json) : json;
      if (
        window.drupalSettings.form_builder &&
        window.drupalSettings.form_builder[this.nid]
      ) {
        let evaluation_type =
          window.drupalSettings.form_builder[this.nid].evaluation_type;

        // Add self evaluation
        if (evaluation_type == "self_scored" && p_json[0].type == "FbStep") {
          let rubricData =
            this.sid != "" &&
            window.drupalSettings.form_builder[this.nid]["submissions"][
              this.sid
            ].rubric
              ? window.drupalSettings.form_builder[this.nid]["submissions"][
                  this.sid
                ].rubric.items
              : window.drupalSettings.form_builder[this.nid].rubric_template;

          let selfEvaluationStep = [
            {
              type: "FbStep",
              data: {
                label: "Self Evaluation",
                value: false,
              },
              list: [],
              uuid: "self_evaluation",
            },
            {
              type: "FbRubric",
              data: {
                label: "Rubric",
                value: rubricData,
              },
              list: [],
              uuid: "rubric",
            },
          ];
          p_json = p_json.concat(selfEvaluationStep);
        }
      }

      //get latest submission
      if (json != "" && p_json) {
        this.list = p_json;
        return;
      }
    }
    this.list.map(this.set_uuid);
  },
  computed: {
    showSubmit() {
      if (this.content && this.content === true) {
        return false;
      }
      if (this.submitted == false) {
        if (
          (this.status == this.$status.ACTIVITY_COMPLETED &&
            this.resubmit == true) ||
          this.status == this.$status.ACTIVITY_IN_PROGRESS ||
          this.status == this.$status.ACTIVITY_NEEDS_WORK
        ) {
          return true;
        }
        if ((this.sid !== "" && this.resubmit === true) || this.sid === "") {
          return true;
        }
      }
      if (this.submitted === true && this.resubmit === false) {
        return false;
      } else if (this.submitted === true && this.resubmit === true) {
        return true;
      }
      return false;
    },
    valid: {
      cache: false,
      get() {
        if (this.isDraft) {
          return true;
        }
        let errors = this.validation.filter((el) => {
          return el !== true;
        });
        return errors.length == 0;
      },
    },
    files() {
      let files = [];
      for (let key in this.value) {
        if (!this.value.hasOwnProperty(key)) {
          return;
        }
        if (this.value[key].type == "FbFile") {
          this.value[key].value.map((file) => {
            if (file.type == "file" && file.uuid && file.uuid != "") {
              files.push(file.uuid);
            }
          });
        }
      }

      return files;
    },
    videos() {
      let files = [];
      for (let key in this.value) {
        if (!this.value.hasOwnProperty(key)) {
          return;
        }
        if (this.value[key].type == "FbVideo") {
          this.value[key].value.map((file) => {
            if (file.type == "file" && file.uuid && file.uuid != "") {
              files.push(file.uuid);
            }
          });
        }
      }

      return files;
    },
    countFormCards() {
      let json = JSON.parse(this.json);
      let countFormCards = 0;
      let countForm = (elements, parent) => {
        elements.forEach((el, index) => {
          el.list = countForm(el.list, el);
          if (el.type == "FbCard" && el.data.type == "form") {
            countFormCards++;
          }
        });
        return countFormCards;
      };
      return countForm(json);
    },
    json() {
      return JSON.stringify(this.list);
    },
    jsonView() {
      let steps = [];
      let inStep = false;
      let json = JSON.parse(this.json);
      let countFormCards = 0;
      let reorderList = (elements, parent) => {
        let prevElementType = null;
        let list = [];
        elements.forEach((el, index) => {
          el.list = reorderList(el.list, el);
          if (el.type == "FbStep" && prevElementType == "FbStep") {
            list[list.length - 1].list.push(el);
          } else if (el.type == "FbStep") {
            if (
              parent &&
              parent.type == "FbCard" &&
              parent.data.type == "step"
            ) {
              list.push({
                type: "FbSlider",
                data: {},
                list: [],
              });
            } else if (
              parent &&
              parent.type == "FbCard" &&
              parent.data.type == "form"
            ) {
              list.push({
                type: "FbSliderForm",
                data: {},
                list: [],
              });
            } else {
              list.push({
                type: "FbStepper",
                data: {},
                list: [],
              });
            }
            list[list.length - 1].list.push(el);
          } else if (el.type == "FbLayout" && prevElementType == "FbLayout") {
            list[list.length - 1].list.push(el);
          } else if (el.type == "FbLayout") {
            list.push({
              type: "FbWrapper",
              data: {},
              list: [],
            });
            list[list.length - 1].list.push(el);
          } else {
            list.push(el);
          }
          prevElementType = el.type;
        });
        return list;
      };
      let result = reorderList(json);
      return result;
    },
  },
  data() {
    return {
      evaluation_type: drupalSettings.evaluation_type,
      webform_template: this.webform_template || false,
      view_mode: this.mode || false,
      isDraft:
        this.sid && this.sid != ""
          ? window.drupalSettings.form_builder[this.nid]["submissions"][
              this.sid
            ].isDraft
          : true,
      isFinal:
        this.sid &&
        this.sid != "" &&
        !window.drupalSettings.form_builder[this.nid]["submissions"][this.sid].isDraft &&
        window.drupalSettings.form_builder[this.nid]["submissions"][this.sid].type == 1
          ? true
          : false,
      validate: false,
      validate_last_step: false,
      list: this.elements || [],
      value: {},
      showLoader: false,
      sending: false,
      token: "",
      validation: [],
      autosave: null,
      autosaveEnabled: window.drupalSettings.user.role != 'administrator' &&
        window.drupalSettings.user.role != 'content_creator' &&
        window.drupalSettings.user.role != 'content_manager' &&
        window.drupalSettings.user.role != 'subgroup_administrator' &&
        window.drupalSettings.user.role != 'group_administrator',
      submitted: false,
      show_submitted: false,
      submission_uuid: this.sid,
      submission_id:
        this.sid && this.sid != ""
          ? window.drupalSettings.form_builder[this.nid]["submissions"][
            this.sid
            ].entity_id
          : 0,
      draft_submission_uuid: this.draft_sid,
      autosave_interval: window.drupalSettings.autosave_time_interval
        ? window.drupalSettings.autosave_time_interval
        : "5",
      status:
        this.sid && this.sid != ""
          ? window.drupalSettings.form_builder[this.nid]["submissions"][
              this.sid
            ].status
          : this.$status.ACTIVITY_NOT_STARTED,
      resubmit:
        window.drupalSettings.form_builder &&
        window.drupalSettings.form_builder[this.nid]
          ? window.drupalSettings.form_builder[this.nid].resubmit
          : false,
      is_closed: window.drupalSettings.node.is_closed || false,
      closed_message: window.drupalSettings.node.closed_at ? 'Submissions closed as of ' + window.drupalSettings.node.closed_at + '.': '',
    };
  },
  methods: {
    log(data) {
      console.log(data);
    },
    startAutosave() {
      let self = this;
      // Autosave.
      window.clearInterval(window.autosave);
      let autosaveInterval = this.autosave_interval * 1000;
      window.autosave = window.setInterval(function () {
        if (!self.sending) {
          self.sending = true;
          self.submitDraft((e) => {});
        }
        //self.submitDraft();
      }, autosaveInterval);
    },
    stopAutosave() {
      clearInterval(window.autosave);
    },
    set_uuid(element) {
      if (!element.uuid) {
        element.uuid = this.$uuid.v1();
      }
      element.list.forEach((el) => {
        if (!el.uuid) {
          el.uuid = this.$uuid.v1();
        }
        if (el.list && el.list.length) {
          this.set_uuid(el);
        }
      });
      return element;
    },
    clone(el) {
      return this.set_uuid({
        type: el.type,
        list: el.list.slice(),
        data: Object.assign({}, el.data),
      });
    },
    setValue(value) {
      if (value) {
        this.value[value.uuid] = JSON.parse(JSON.stringify(value));
        //trigger reload
        this.value = {
          ...this.value,
        };
      }
    },
    submitDraft(callback) {
      // Do not perform saving if there are MAIN type submission or activity is completed.
      if (!this.autosaveEnabled) {
        return callback(true);
      }
      if (this.status == this.$status.ACTIVITY_COMPLETED) {
        // Clear autosave in case it's still exist.
        clearInterval(window.autosave);
        return callback(true);
      }
      //if (!this.sending) {
      //  this.sending = true;
        this.sendDraft().then((json) => {
          //this.showLoader = false;
          this.submitted = true;
          this.draft_submission_uuid = json.data.id;
          this.sending = false;
          return callback(true);
        }).catch(()=>{
          return callback(false);
        });
      //}
      // return callback(false);
    },
    validateForm() {
      this.validate = true;
      this.isDraft = false;
    },
    disableFormValidation() {
      this.validate = false;
    },
    async submit() {
      if (!this.valid) {
        return;
      }
      this.showLoader = true;
      await this.sendDraft();
      let createdSubmission = await this.sendActivity();
      let submission = await this.getSubmission(createdSubmission.data.id);

      this.status = submission.data.attributes.status_code;
      this.showLoader = false;
      //this.status = this.$status.ACTIVITY_COMPLETED;
      this.isFinal = true;
      this.submitted = true;
      this.show_submitted = false;

      if (this.field == "activity_form") {
        let path = "/activity/" + this.$route.params.id + "/thanks";
        if (this.status == this.$status.ACTIVITY_COMPLETED) {
          path = "/activity/" + this.$route.params.id + "/thanks/completed";
        }
        this.$router.push({ path });
      }
      if (this.field == "field_set_form") {
        let path = "/strategy/" + this.$route.params.id + "/set/thanks";
        this.$router.push({ path });
      }
      if (this.field == "field_go_form") {
        let path = "/strategy/" + this.$route.params.id + "/go/thanks";
        if (this.status == this.$status.ACTIVITY_COMPLETED) {
          path = "/strategy/" + this.$route.params.id + "/go/thanks/completed";
        }
        this.$router.push({ path });
      }

      if (document.querySelector(".md-app-scroller")) {
        document.querySelector(".md-app-scroller").scrollTop = 0;
      }
      window.scrollTop = 0;
    },
    updateValidation(index, event) {
      this.validation[index] = event;
      this.validation = this.validation.slice(0);
      this.$emit("validation", this.valid);
    },
    getToken(isDraft) {
      return RestHelpers.getToken()
        .then((text) => {
          this.token = text;
          return text;
        })
        .catch((err) => {
          if (isDraft) {
            console.log(err);
            return;
          }
          if (this.field == "field_set_form") {
            let path = "/strategy/" + this.$route.params.id + "/set/error";
            this.$router.push({ path });
          }
          if (this.field == "field_go_form") {
            let path = "/strategy/" + this.$route.params.id + "/go/error";
            this.$router.push({ path });
          }
          if (this.field == "activity_form") {
            let path = "/activity/" + this.$route.params.id + "/error";
            this.$router.push({ path });
          }
        });
    },
    sendDraft() {
      return this.sendActivityRequest(true, this.draft_submission_uuid);
    },
    sendActivity() {
      // Clear autosave in case it's still exist.
      clearInterval(window.autosave);
      return this.sendActivityRequest(false, this.submission_uuid).catch(
        (e) => {
          this.showLoader = false;
          if (this.field == "activity_form") {
            let path = "/activity/" + this.$route.params.id + "/error";
            this.$router.push({ path });
          }
          if (this.field == "field_set_form") {
            let path = "/strategy/" + this.$route.params.id + "/set/error";
            this.$router.push({ path });
          }
          if (this.field == "field_go_form") {
            let path = "/strategy/" + this.$route.params.id + "/go/error";
            this.$router.push({ path });
          }
          if (document.querySelector(".md-app-scroller")) {
            document.querySelector(".md-app-scroller").scrollTop = 0;
          }
          window.scrollTop = 0;
        }
      );
    },
    sendActivityRequest(isDraft, suuid) {
      let self = this;
      let type = isDraft
        ? self.$submission_type.SUBMISSION_TYPE_TEMP
        : self.$submission_type.SUBMISSION_TYPE_MAIN;
      return self.getToken(isDraft).then(() => {
        let fetch_headers = new Headers();
        fetch_headers.append("Content-Type", "application/vnd.api+json");
        fetch_headers.append("X-CSRF-Token", self.token);
        let method = suuid && suuid != "" ? "PATCH" : "POST";
        let value = JSON.parse(JSON.stringify(self.value));
        value.isDraft = isDraft;
        let allFiles = this.files.concat(this.videos);
        let a_data = {
          data: {
            type: "activity_submission--activity_submission",
            attributes: {
              data: JSON.stringify(value),
              submission_type: type,
              section: self.field,
              is_draft: isDraft,
            },
            relationships: {
              activity: {
                data: {
                  type: "node--activity",
                  id: self.nid,
                },
              },
              webform_template: {
                data: {
                  type: "webform_template--webform_template",
                  id:
                    window.drupalSettings.form_builder[self.nid].tabs[
                      self.field
                    ].template.uuid,
                },
              },
              attached_files: {
                data: allFiles.map((uuid) => {
                  return {
                    type: "file--file",
                    id: uuid,
                  };
                }),
              },
            },
          },
        };

        let entity_uuid = "";
        if (method == "PATCH") {
          a_data.data.id = suuid;
          entity_uuid = "/" + suuid;
        }

        return fetch(
          "/jsonapi/activity_submission/activity_submission" + entity_uuid,
          {
            credentials: "include",
            method: method,
            headers: fetch_headers,
            body: JSON.stringify(a_data),
          }
        )
          .then((response) => {
            return response.json();
          })
          .then((json) => {
            if (json && json.errors && json.errors.length) {
              throw new Error(json.errors[0].title);
            }
            // if (json.data && json.data.id) {
            //   self.$emit("set-sid", json.data.id);
            // }
            if (json.data && json.data.id) {
              suuid = json.data.id;
              if (isDraft) {
                this.draft_submission_uuid = json.data.id;
              } else {
                this.submission_uuid = json.data.id;

                this.status = json.data.attributes.status_code;
                this.$emit("set-sid", json.data.id);
              }
            }
            return json;
          });
      });
    },
    getSubmission(id) {
      let fetch_headers = new Headers();
      fetch_headers.append("Content-Type", "application/vnd.api+json");
      fetch_headers.append("X-CSRF-Token", self.token);
      return fetch("/jsonapi/activity_submission/activity_submission/" + id, {
        credentials: "include",
        method: "GET",
        headers: fetch_headers,
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          return json;
        });
    },
    getSubmissionLink(id) {
      if (id === 0) {
        return '';
      }
      return "<a href='/activity-submission-learner/" + id + "'>View Submission</a>";
    },
  },
  watch: {
    elements(newElements) {
      this.list = newElements;
    },
    sid(uid) {
      this.submission_uuid = uid;
    },
    valid(newVal) {
      if (newVal === true) {
        this.validate = false;
      }
    },
    status(newStatus) {
      this.$emit("change-status", newStatus);
    }
  },
};
</script>

<style lang="scss">
.module-strategy,
.module-activity {
  .rubrics-content {
    overflow: hidden;
    > ul {
      li {
        .md-list-expand {
          @media all and (max-width: $breakpoint-medium) {
            > div {
              .criteria-title {
                padding: 30px 0px;
                background: #eeeeee;
              }
               .criteria-content:first-child {
                > div:first-child {
                  border-top-left-radius: 20px;
                  border-top-right-radius: 20px;
                }
                > div:last-child {
                  border-top-right-radius: unset !important;
                  border-top-left-radius: unset !important;
                }
              }
              .average-score {
                display: none;
              }
            }
          }
          > div {
            padding-left: 25px;
            padding-right: 25px;
            .criteria-content:first-child {
              overflow: hidden;
              > div:first-child {
                border-top-left-radius: 20px;
              }
              > div:last-child {
                border-top-right-radius: 20px;
              }
            }
          }
          .score {
            margin-bottom: 25px;
            border-bottom-right-radius: 20px;
            border-bottom-left-radius: 20px;
          }
        }
        .md-radio-container {
          border-color: $blue-active !important;
        }
        .md-radio.md-theme-default.md-checked
          .md-radio-container.md-radio-container:after {
          background-color: $blue-active !important;
        }
      }
    }
  }
}

.md-card.md-theme-default.fb-info-message {
  background-color: #d4f1c8 !important;
  text-align: left;
  padding: 20px;
  margin-bottom: 10px;
  margin-top: 10px;
  border-radius: 20px;
}

.vjs-tree.is-root {
  text-align: left;
}

.builder::after {
  clear: both;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.md-field.md-invalid {
  &.fb-select {
    margin-bottom: 0px !important;
  }
  margin-bottom: 50px !important;
}

span.md-error {
  background-repeat: no-repeat;
  background-position: left 10px center;
  background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='14px' height='14px' viewBox='0 0 14 14' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3C!-- Generator: Sketch 56 (81588) - https://sketch.com --%3E%3Ctitle%3E-g-24px (11) copy%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='-g-24px-(11)-copy' transform='translate(-1.000000, -1.000000)'%3E%3Cpolygon id='Path' points='0 0 16 0 16 16 0 16'%3E%3C/polygon%3E%3Cpath d='M8,1.33333333 C4.32,1.33333333 1.33333333,4.32 1.33333333,8 C1.33333333,11.68 4.32,14.6666667 8,14.6666667 C11.68,14.6666667 14.6666667,11.68 14.6666667,8 C14.6666667,4.32 11.68,1.33333333 8,1.33333333 Z M8.66666667,11.3333333 L7.33333333,11.3333333 L7.33333333,10 L8.66666667,10 L8.66666667,11.3333333 Z M8.66666667,8.66666667 L7.33333333,8.66666667 L7.33333333,4.66666667 L8.66666667,4.66666667 L8.66666667,8.66666667 Z' id='Shape' fill='%23E63950' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  display: block;
  padding: 8px 40px 8px 30px;
  bottom: -50px !important;
  color: rgb(230, 57, 80);
  font-family: $font-source-sans-pro;
  font-size: 14px !important;
  margin-top: 16px;
  text-align: left;
  font-weight: normal;
  min-height: 40px !important;
  width: 100%;
  background-color: rgba(255, 246, 248, 0.8);
  border-radius: 32px;
}

.messages__wrapper {
  .messages--link {
    float: right;
    a {
      color: rgb(10, 90, 39)!important;
      font-size: 16px!important;
      font-weight: normal;
      font-family: $font-source-sans-pro;
      text-decoration: underline;

      &:hover {
        text-decoration: none;
      }
    }
  }
}
</style>
